export enum ETextAlignement {
    CENTER = 'center',
    JUSTIFY = 'justify',
    LEFT = 'left',
    RIGHT = 'right',
}
